
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/wamglammz-logo.png";
import logo2 from "../../assets/wamglammz-logo2.png";
import specialistImage from "../../assets/spec1.png";
import { clearAuthSession, getImageUrl } from "../../lib/api";
import { navigation } from "../../utils/vendor/vendorUtils";

export function WorkspaceHeader({
    mobileNavOpen,
    setMobileNavOpen,
    profile,
    hasNewNotification,
    notifications = [],
    onClearNotifications,
    onClearBadge,
    onTabChange,
    onNotificationClick
}) {
    console.log("Function called: WorkspaceHeader");
    const [openDropdown, setOpenDropdown] = useState(false);
    const [visibleCount, setVisibleCount] = useState(10);
    const dropdownRef = useRef(null);
    const vendorName = profile?.branding_settings?.businessName || profile?.name || "Vendor";
    const profileImage = profile?.branding_settings?.profileImageUrl
        ? getImageUrl(profile.branding_settings.profileImageUrl)
        : specialistImage;

    useEffect(() => {
        if (!openDropdown) {
            setVisibleCount(10);
            return;
        }

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdown(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    return (
        <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur">
            <div className="flex h-16 items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
                <div className="flex min-w-0 items-center gap-3">
                    <button
                        type="button"
                        onClick={() => setMobileNavOpen(!mobileNavOpen)}
                        className="grid h-10 w-10 place-items-center rounded-lg border border-slate-200 text-slate-700 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700 lg:hidden"
                        aria-label="Open workspace navigation"
                        aria-expanded={mobileNavOpen}
                    >
                        <i className="fa-solid fa-bars" aria-hidden="true" />
                    </button>

                    <Link to="/for-business/dashboard" className="flex min-w-0 items-center gap-2">
                        <img src={logo} alt="WamGlammz" className="h-9 w-auto object-contain" />
                        <img src={logo2} alt="WamGlammz" className="hidden h-6 w-auto object-contain sm:block" />
                    </Link>

                    <span className="hidden h-6 w-px bg-slate-200 lg:block" aria-hidden="true" />
                    <p className="hidden text-sm font-bold text-slate-600 lg:block">Vendor Workspace</p>
                </div>

                {/* <label className="hidden h-10 min-w-0 max-w-md flex-1 items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm text-slate-500 transition focus-within:border-blue-300 focus-within:bg-white focus-within:ring-4 focus-within:ring-blue-50 md:flex">
                    <i className="fa-solid fa-magnifying-glass text-slate-400" aria-hidden="true" />
                    <input
                        type="search"
                        placeholder="Search bookings, clients, services"
                        className="min-w-0 flex-1 bg-transparent font-semibold outline-none placeholder:text-slate-400"
                    />
                </label> */}

                <div className="flex shrink-0 items-center gap-2">
                    {/* {bookingSlug && (
                        <Link
                            to={`/book/${bookingSlug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hidden h-10 items-center gap-2 rounded-lg border border-blue-200 px-3 text-sm font-bold text-blue-700 transition hover:bg-blue-50 md:flex"
                        >
                            <i className="fa-solid fa-eye" aria-hidden="true" />
                            Preview
                        </Link>
                    )} */}

                    <div className="relative" ref={dropdownRef}>
                        <button
                            type="button"
                            onClick={() => {
                                setOpenDropdown(!openDropdown);
                                if (hasNewNotification && onClearBadge) {
                                    onClearBadge();
                                }
                            }}
                            className="relative grid h-10 w-10 place-items-center rounded-lg border border-slate-200 text-slate-600 transition hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                            aria-label="Notifications"
                        >
                            <i className="fa-regular fa-bell" aria-hidden="true" />
                            {hasNewNotification && (
                                <span className="absolute right-2.5 top-2.5 flex h-2 w-2">
                                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75"></span>
                                    <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500"></span>
                                </span>
                            )}
                        </button>

                        {openDropdown && (
                            <div className="absolute right-0 top-12 z-50 w-80 rounded-2xl border border-slate-100 bg-white p-4 shadow-[0_20px_50px_rgba(15,23,42,0.12)]">
                                <div className="flex items-center justify-between border-b border-slate-100 pb-2 mb-2">
                                    <h3 className="text-sm font-extrabold text-slate-900">Notifications</h3>
                                    {notifications.length > 0 && (
                                        <button
                                            type="button"
                                            onClick={() => {
                                                if (onClearNotifications) onClearNotifications();
                                                setOpenDropdown(false);
                                            }}
                                            className="text-xs font-bold text-blue-600 hover:underline"
                                        >
                                            Clear all
                                        </button>
                                    )}
                                </div>
                                <div className="max-h-[360px] overflow-y-auto space-y-2 pr-1">
                                    {notifications.length > 0 ? (
                                        <>
                                            {notifications.slice(0, visibleCount).map((notif, idx) => {
                                                const messageText = typeof notif === "object" && notif !== null ? notif.message : notif;
                                                const notifDate = typeof notif === "object" && notif !== null ? notif.date : null;
                                                return (
                                                    <div
                                                        key={idx}
                                                        onClick={() => {
                                                            if (notifDate && onNotificationClick) {
                                                                onNotificationClick(notifDate);
                                                            } else if (onTabChange) {
                                                                onTabChange("calendar");
                                                            }
                                                            setOpenDropdown(false);
                                                        }}
                                                        className="rounded-xl border border-slate-100 bg-slate-50/70 p-3 text-xs font-semibold leading-relaxed text-slate-700 flex items-start gap-2 shadow-sm cursor-pointer hover:bg-slate-100 transition"
                                                    >
                                                        <span className="h-1.5 w-1.5 mt-1.5 shrink-0 rounded-full bg-emerald-500" />
                                                        <span>{messageText}</span>
                                                    </div>
                                                );
                                            })}
                                            {notifications.length > visibleCount && (
                                                <button
                                                    type="button"
                                                    onClick={() => setVisibleCount(prev => prev + 10)}
                                                    className="w-full py-2.5 text-center text-xs font-bold text-blue-600 hover:text-blue-700 hover:bg-blue-50/50 rounded-xl transition border border-dashed border-blue-200 mt-2 block"
                                                >
                                                    Load more
                                                </button>
                                            )}
                                        </>
                                    ) : (
                                        <div className="py-6 text-center text-xs font-semibold text-slate-400">
                                            <i className="fa-regular fa-bell-slash text-lg block mb-1 text-slate-300" />
                                            No new notifications
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="hidden items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2 sm:flex">
                        <img src={profileImage} alt={vendorName} className="h-8 w-8 rounded-lg object-cover" />
                        <div className="hidden leading-tight xl:block">
                            <p className="text-sm font-extrabold text-slate-900">{vendorName}</p>
                            <p className="text-xs font-semibold text-slate-500">Owner account</p>
                        </div>
                    </div>

                    <Link
                        to="/for-business/login"
                        onClick={clearAuthSession}
                        className="hidden h-10 items-center gap-2 rounded-lg bg-slate-900 px-3 text-sm font-bold text-white transition hover:bg-slate-800 sm:flex"
                    >
                        <i className="fa-solid fa-arrow-right-from-bracket" aria-hidden="true" />
                        Logout
                    </Link>
                </div>
            </div>
        </header>
    );
}

export function WorkspaceSidebar({ activeTab, setActiveTab, onNavigate, profile }) {
    console.log("Function called: WorkspaceSidebar");
    const handleNavigate = (key) => {
        console.log("Function called: handleNavigate");
        setActiveTab(key);
        if (onNavigate) onNavigate();
    };

    const vendorName = profile?.branding_settings?.businessName || profile?.name || "Your Studio";
    const vendorCategory = profile?.branding_settings?.tagline;

    const bookingSlug = profile?.booking_slug || "";
    const profileImage = profile?.branding_settings?.profileImageUrl
        ? getImageUrl(profile.branding_settings.profileImageUrl)
        : specialistImage;

    const currentPlan = profile?.subscription_plan || "trial";
    const currentStatus = profile?.subscription_status || "active";
    const isSubscribed = currentPlan !== "trial" && currentStatus === "active";

    let planTitle = "";
    let planDescription = "";

    if (currentPlan === "trial") {
        const trialEndsDate = profile?.trial_ends_at ? new Date(profile.trial_ends_at) : null;
        let daysLeft = 14;
        if (trialEndsDate) {
            const diffTime = trialEndsDate.getTime() - Date.now();
            daysLeft = Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
        }
        planTitle = "Studio Trial";
        planDescription = `${daysLeft} day${daysLeft !== 1 ? "s" : ""} left. Billing is connected through Stripe.`;
    } else {
        planTitle = currentPlan.replace(/_/g, " ");
        planDescription = currentStatus === "active"
            ? "Subscription active. Billing is connected through Stripe."
            : `Subscription status is ${currentStatus}. Managed via Stripe.`;
    }

    return (
        <div className="space-y-4">
            <section className="rounded-2xl border border-blue-100 bg-white p-5 shadow-[0_16px_45px_rgba(14,63,182,0.07)]">
                <div className="flex items-center gap-4">
                    <img src={profileImage} alt={vendorName} className="h-16 w-16 rounded-2xl object-cover" />
                    <div>
                        <h2 className="font-extrabold text-[#191E49]">{vendorName}</h2>
                        <p className="text-sm font-semibold text-slate-500">{vendorCategory}</p>
                    </div>
                </div>
                <div className="mt-5 rounded-xl bg-blue-50 p-4 relative overflow-hidden">
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-blue-700">Booking URL</p>
                    {isSubscribed ? (
                        bookingSlug ? (
                            <Link
                                to={`/book/${bookingSlug}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="mt-2 block break-all text-sm font-bold text-blue-700 hover:underline"
                            >
                                /book/{bookingSlug}
                            </Link>
                        ) : (
                            <p className="mt-2 text-xs font-semibold text-slate-400 italic">Slug not set — check artist profile email matches admin email</p>
                        )
                    ) : (
                        <div className="relative mt-2">
                            {/* Blurred Text */}
                            <p className="select-none text-sm font-bold text-blue-700/30 filter blur-[3px] break-all">
                                /book/hidden-slug-upgrade-needed
                            </p>
                            {/* Lock Overlay */}
                            <div className="absolute inset-0 flex items-center justify-start gap-1.5 text-xs font-extrabold text-blue-600">
                                <i className="fa-solid fa-lock text-[10px]" />
                                <span>Available with Subscription</span>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            <nav className="rounded-2xl border border-blue-100 bg-white p-2 shadow-[0_16px_45px_rgba(14,63,182,0.07)]" aria-label="Workspace navigation">
                {navigation.map((item) => (
                    <button
                        type="button"
                        key={item.key}
                        onClick={() => handleNavigate(item.key)}
                        className={`mb-1 flex h-11 w-full items-center gap-3 rounded-xl px-3 text-left text-sm font-bold transition last:mb-0 ${activeTab === item.key
                            ? "bg-gradient-to-r from-[#0A3FB6] to-[#2FB4FF] text-white shadow-lg shadow-blue-100"
                            : "text-slate-600 hover:bg-blue-50 hover:text-blue-700"
                            }`}
                    >
                        <i className={`fa-solid ${item.icon} w-5 text-center`} aria-hidden="true" />
                        <span className="flex-1 truncate text-left">{item.label}</span>
                        {!isSubscribed && (item.key === "calendar" || item.key === "booking") && (
                            <i className="fa-solid fa-lock text-[10px] text-slate-400" />
                        )}
                    </button>
                ))}
            </nav>

            <section className="rounded-2xl border border-slate-200 bg-slate-900 p-5 text-white shadow-[0_16px_45px_rgba(15,23,42,0.12)]">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-blue-200">Plan</p>
                <h3 className="mt-2 text-lg font-extrabold capitalize">{planTitle}</h3>
                <p className="mt-2 text-sm font-semibold leading-6 text-slate-300">{planDescription}</p>
            </section>
        </div>
    );
}